module.exports = __webpack_public_path__ + "static/DasaSans-Regular-a2c4759bd5ec291912de553b5167d225.ttf";